// extracted by mini-css-extract-plugin
module.exports = {"logo":"style_logo__koG2P","collapsed":"style_collapsed__363vw","text":"style_text__17Kxg","symbol":"style_symbol__3Dsus"};